import { deserialize, deserializeAs } from 'libs/cerialize';
import { ViewGridModel } from 'Core/Controls/Grid/Models/ViewGridModel';

export class ViewGridResponseModel { 
	@deserializeAs(ViewGridModel)
	GridViews: Array<ViewGridModel>;

	@deserialize
	IsAddingRecordAllowed : boolean;
}